import React from 'react';
import { Button } from 'antd';
import { ActionIcon } from '@icons';

type DropdownMenuButtonProps = {
  onOpenChange: (prev: any) => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
};
function DropdownMenuButton({
  onOpenChange,
  disabled = false,
  loading = false,
  className
}: DropdownMenuButtonProps) {
  const onClick = (e: any) => {
    e.stopPropagation();
    onOpenChange((prev: boolean) => !prev);
  };
  return (
    <div className={className || 'dropdown-menu-button-container'}>
      <Button
        type="text"
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        size="small"
        style={{ padding: 0 }}
      >
        <ActionIcon
          style={{ marginLeft: 0, marginRight: 0, fontSize: '24px' }}
        />
      </Button>
    </div>
  );
}

export default DropdownMenuButton;
